import React, { createContext, useContext, useMemo } from "react";
import { doc } from "firebase/firestore";
import { db } from "../../firebase";
import { useSession } from "../../auth/AuthProvider";
import { useLiveDoc } from "../../hooks/useLive";

// A distributor's own record (name, quota) is the only thing loaded up
// front. Keys and customers are read a page at a time, always filtered on
// distributorId == their id; firestore.rules rejects anything broader.
const DistributorDataContext = createContext(null);

export const useDistributorData = () => useContext(DistributorDataContext);

export function DistributorDataProvider({ children }) {
  const { distributorId } = useSession();
  const distributor = useLiveDoc(`distributors/${distributorId}`, () =>
    doc(db, "distributors", distributorId),
  );

  const value = useMemo(
    () => ({
      distributorId,
      distributor: distributor.data,
      distributorLoading: distributor.loading,
      error: distributor.error,
    }),
    [distributorId, distributor],
  );

  return (
    <DistributorDataContext.Provider value={value}>
      {children}
    </DistributorDataContext.Provider>
  );
}
